<template>
  <v-container>
    <h3>系統設定</h3>
    <v-row class="my-4">
      <v-col cols="12">
        <v-row>
          <v-col cols="4">
            <v-text-field
              v-model="deleteUserId"
              label="輸入要刪除的推播帳號"
              outlined
              hide-details
            ></v-text-field>
          </v-col>
          <v-col cols="4" class="d-flex align-center">
            <v-btn color="error" @click="removeNotify"> 刪除推播 </v-btn>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
    <v-divider class="my-4"></v-divider>
    <v-row>
      <v-col cols="12">
        <v-checkbox
          v-model="configs.announcement.enable"
          label="啟用前台公告"
          hide-details
        ></v-checkbox>
      </v-col>
      <v-col cols="12">
        <v-textarea
          v-model="configs.announcement.content"
          label="系統前台公告"
          outlined
          hide-details
        >
        </v-textarea>
      </v-col>
      <v-col cols="12" class="text-right">
        <v-btn color="primary" @click="save('announcement')">儲存</v-btn>
      </v-col>
    </v-row>
    <v-divider class="my-4"></v-divider>
    <v-row>
      <v-col cols="12">
        <v-checkbox
          v-model="configs.announcementDashboard.enable"
          label="啟用後台公告"
          hide-details
        ></v-checkbox>
      </v-col>
      <v-col cols="12">
        <v-textarea
          v-model="configs.announcementDashboard.content"
          label="系統後台公告"
          outlined
          hide-details
        >
        </v-textarea>
      </v-col>
      <v-col cols="12" class="text-right">
        <v-btn color="primary" @click="save('announcementDashboard')"
          >儲存</v-btn
        >
      </v-col>
    </v-row>
    <v-divider class="my-4"></v-divider>
    <v-row>
      <v-col cols="12">
        <h4>SMTP 設定（預約清冊寄送）</h4>
      </v-col>
      <v-col cols="12" sm="6">
        <v-text-field
          v-model="configs.smtpReserveList.host"
          label="SMTP Host"
          outlined
          hide-details
        ></v-text-field>
      </v-col>
      <v-col cols="12" sm="3">
        <v-text-field
          v-model.number="configs.smtpReserveList.port"
          label="SMTP Port"
          outlined
          hide-details
        ></v-text-field>
      </v-col>
      <v-col cols="12" sm="3">
        <v-checkbox
          v-model="configs.smtpReserveList.secure"
          label="使用 SSL (secure)"
          hide-details
        ></v-checkbox>
      </v-col>
      <v-col cols="12" sm="6">
        <v-text-field
          v-model="configs.smtpReserveList.user"
          label="SMTP 帳號"
          outlined
          hide-details
        ></v-text-field>
      </v-col>
      <v-col cols="12" sm="6">
        <v-text-field
          v-model="configs.smtpReserveList.pass"
          label="SMTP 密碼"
          outlined
          hide-details
          type="password"
        ></v-text-field>
      </v-col>
      <v-col cols="12" sm="6">
        <v-text-field
          v-model="configs.smtpReserveList.from"
          label="寄件者（From）"
          outlined
          hide-details
        ></v-text-field>
      </v-col>
      <v-col cols="12" sm="6">
        <v-checkbox
          v-model="configs.smtpReserveList.tlsRejectUnauthorized"
          label="TLS 驗證憑證"
          hide-details
        ></v-checkbox>
      </v-col>
      <v-col cols="12" class="text-right">
        <v-btn color="primary" @click="save('smtpReserveList')">儲存</v-btn>
      </v-col>
    </v-row>
    <v-divider class="my-4"></v-divider>
    <v-row>
      <v-col cols="12">
        <h4>後台連結設定</h4>
      </v-col>
      <v-col cols="12">
        <v-text-field
          v-model="configs.reserveListNotifyBaseUrl"
          label="預約清冊後台基底網址（例如 https://example.com）"
          outlined
          hide-details
        ></v-text-field>
      </v-col>
      <v-col cols="12" class="text-right">
        <v-btn color="primary" @click="save('reserveListNotifyBaseUrl')"
          >儲存</v-btn
        >
      </v-col>
      <v-col cols="12">
        <v-text-field
          v-model="configs.accountActivationBaseUrl"
          label="帳號核准設定密碼基底網址（例如 https://example.com）"
          outlined
          hide-details
        ></v-text-field>
      </v-col>
      <v-col cols="12" class="text-right">
        <v-btn color="primary" @click="save('accountActivationBaseUrl')"
          >儲存</v-btn
        >
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import dayjs from "dayjs";
import _ from "lodash";
export default {
  name: "System",
  data: () => ({
    configs: {
      announcement: {
        enable: false,
        content: null,
      },
      announcementDashboard: {
        enable: false,
        content: null,
      },
      smtpReserveList: {
        host: "",
        port: 587,
        secure: false,
        user: "",
        pass: "",
        from: "",
        tlsRejectUnauthorized: true,
      },
      reserveListNotifyBaseUrl: "",
      accountActivationBaseUrl: "",
    },
    deleteUserId: null,
  }),
  computed: {},
  created() {
    this.load();
  },
  methods: {
    async load() {
      let configs = (await this.axios.get("/dashboard/configs")).data;
      _.each(configs, (v, k) => {
        this.configs[k] = v;
      });
    },
    async save(k) {
      let data = {
        key: k,
        value: this.configs[k],
      };
      await this.axios.post("/dashboard/configs", data);
      this.$toast.success("已儲存");
    },
    async removeNotify() {
      await this.axios.delete(`/dashboard/person/notify/${this.deleteUserId}`);
      this.$toast.success(`已刪除 ${this.deleteUserId} 的剩餘推播`);
    },
  },
};
</script>

<style lang="scss" scoped></style>
